var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":"is-dark"}},[_c('div',{staticClass:"level is-mobile"},[_c('div',{staticClass:"level-item"},[_c('Tokens',{attrs:{"tokens":_vm.tokens,"size":"is-small","alignment":"is-left"}})],1),(_vm.symbol)?_c('div',{staticClass:"level-item"},[_c('span',[_vm._v(" "+_vm._s(_vm.symbol)+" ")])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }